import React from 'react'

export default function PaymentMethodItem({ className="col-12", src, alt, heading, onClick }) {
  return (
    <div className={className}>
        <div className="payment-method-item" onClick={onClick}>
            <img className="pmi-img" src={src} alt={alt} />
            <div className="pmi-data-bx">
                <div className="pmi-heading">{heading}</div>
            </div>
        </div>
    </div>
  )
}
